import { render, staticRenderFns } from "./NotasAssociadas.vue?vue&type=template&id=5f5242f1"
import script from "./NotasAssociadas.vue?vue&type=script&lang=js"
export * from "./NotasAssociadas.vue?vue&type=script&lang=js"
import style0 from "./NotasAssociadas.vue?vue&type=style&index=0&id=5f5242f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports